<div class="row">
  <h4>
    {{ myUpcomingWorkshopListLabel }}
  </h4>

  <afra-tab-panel>
    <afra-tab-item
      *ngFor="let group of workshopsByMonth | async"
      [title]="group.title"
    >
      <div class="col-12 mt-4" *ngIf="group.workshops.length === 0">
        <div class="alert alert-light">
          <div class="text-bold text-center">
            فهرست کارگاه‌های پیش‌روی شما خالی است.
          </div>
          <div class="my-3 text-center">
            برای مشاهده و ثبت‌نام در کارگاه‌های آموزشی روی دکمه زیر کلیک کنید.
          </div>
          <div class="mt-3 text-center">
            <button pButton severity="primary" routerLink="/workshops">
              فهرست کارگاه‌های آموزشی
            </button>
          </div>
          <div
            class="text-center mt-4 d-flex flex-sm-row flex-column justify-content-center"
          >
            <span>
              <a
                href="https://afraway.org/ws"
                target="_blank"
                class="link-success"
                >راهنمای ثبت‌نام در کارگاه‌ها</a
              >
            </span>
            <span class="mx-sm-2 d-none d-sm-inline">|</span>
            <div>
              شماره تماس:
              <span class="ms-1"
                ><a class="link-success" href="tel:02191002372">02191002372</a>
              </span>
              <span class="ms-2">داخلی ۱</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-5-grid gap-3">
        <div *ngFor="let workshop of group.workshops" height="250px">
          <app-workshop-card
            [workshop]="workshop"
            [isRegisteredAndPending]="
              pendingWorkshopRegisteredIds.includes(workshop.id)
            "
            [isRegisteredAndApproved]="
              approvedWorkshopRegisteredIds.includes(workshop.id)
            "
            [isRegisteredAndRejected]="
              rejectedWorkshopRegisteredIds.includes(workshop.id)
            "
            [canRegister]="!workshopRegisteredIds.includes(workshop.id)"
            (onRegister)="onRegister($event)"
          >
          </app-workshop-card>
        </div>
      </div>
    </afra-tab-item>
  </afra-tab-panel>

  <app-workshop-register
    *ngIf="showRegisterPopup"
    (onHideWorkshopRegisteringPopup)="onWorkshopRegisteringPopupHide()"
  ></app-workshop-register>
</div>
